/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Sample_One_DetailInputs */

const en_coaches_page_sample_one_detail = /** @type {(inputs: Coaches_Page_Sample_One_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal trainer · from €40`)
};

const pl_coaches_page_sample_one_detail = /** @type {(inputs: Coaches_Page_Sample_One_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerka personalna · od 150 zł`)
};

/**
* | output |
* | --- |
* | "Personal trainer · from €40" |
*
* @param {Coaches_Page_Sample_One_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_sample_one_detail = /** @type {((inputs?: Coaches_Page_Sample_One_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Sample_One_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_sample_one_detail(inputs)
	return en_coaches_page_sample_one_detail(inputs)
});